const messagesFor = value => (Array.isArray(value) ? value : [value])
  .filter(message => typeof message === 'string' && message.trim());

export const clearValidationErrors = root => {
  root.querySelectorAll('[data-server-validation-error]').forEach(element => element.remove());
  root.querySelectorAll('[data-server-invalid]').forEach(element => {
    element.classList.remove('is-invalid');
    element.removeAttribute('data-server-invalid');
    element.removeAttribute('aria-invalid');
  });
};

const findField = (root, key) => {
  const parts = key.split('.');
  const candidates = [key, parts[parts.length - 1]];
  if (parts.length >= 3 && /^\d+$/.test(parts[1])) {
    candidates.unshift(`${parts[parts.length - 1]}-${parts[1]}`);
  }
  if (key === 'customer_id') candidates.push('customer');
  const elements = Array.from(root.querySelectorAll('input,select,textarea,[data-validation-field],[id]'));
  const explicit = elements.find(element => element.getAttribute('data-validation-field') === key);
  if (explicit) return explicit;
  for (const candidate of candidates) {
    const element = elements.find(field => field.id === candidate);
    if (element) return element;
  }
  return elements.find(element => element.getAttribute('name') === key || element.getAttribute('name') === `${key}[]`);
};

export const displayValidationErrors = (errors, message, toastError, requestedForm) => {
  const activeForm = document.activeElement && document.activeElement.closest('form');
  const modalForm = document.querySelector('.modal.show form');
  const root = (requestedForm && requestedForm.isConnected ? requestedForm : null) || modalForm || activeForm || document;
  clearValidationErrors(root);
  const entries = errors && typeof errors === 'object' && !Array.isArray(errors) ? Object.entries(errors) : [];
  const allMessages = [];
  entries.forEach(([key, value]) => {
    const messages = messagesFor(value);
    if (!messages.length) return;
    allMessages.push(...messages);
    const field = findField(root, key);
    if (!field) return;
    const label = document.createElement('div');
    label.className = 'text-danger font-weight-light';
    label.setAttribute('data-server-validation-error', key);
    label.setAttribute('role', 'alert');
    label.textContent = messages.join(' ');
    if (!field.classList.contains('is-invalid')) field.setAttribute('data-server-invalid', 'true');
    field.classList.add('is-invalid');
    field.setAttribute('aria-invalid', 'true');
    const group = field.closest('.form-group');
    if (group) group.appendChild(label);
    else field.parentNode.insertBefore(label, field.nextSibling);
    const clearField = () => {
      label.remove();
      if (field.hasAttribute('data-server-invalid')) {
        field.classList.remove('is-invalid');
        field.removeAttribute('data-server-invalid');
        field.removeAttribute('aria-invalid');
      }
      field.removeEventListener('input', clearField);
      field.removeEventListener('change', clearField);
    };
    field.addEventListener('input', clearField, { once: true });
    field.addEventListener('change', clearField, { once: true });
  });
  toastError([...new Set(allMessages)].join(' · ')
    || (typeof message === 'string' && message.trim())
    || 'Bilgiler kaydedilemedi. Lütfen form alanlarını kontrol edin.');
};
